import { client, useConfig, useElementData } from '@sigmacomputing/plugin'
import { useEffect } from 'react'
import { themeOptions, themes, formatTypesNoPercent } from '../utilities'
import '../data-viz/components/SimpleMetric'
  
export default function Card() {

    useEffect(() => {
        client.config.configureEditorPanel([
            {
                name: "source",
                type: "element",
            },
            {
                name: "value",
                type: "column",
                source: "source",
                allowMultiple: false,
            },
            {
                name: 'label',
                type: 'text',
                secure: false, 
                multiline: false, 
                placeholder: '',
                defaultValue: ''
            },
            {
                name: "percentage",
                type: "column",
                source: "source",
                allowMultiple: false,
            },
            {
                name: 'theme',
                type: 'dropdown',
                values: themeOptions
            },
            {
                name: 'format',
                type: 'dropdown',
                values: formatTypesNoPercent
            },
            {
                name: 'helpText',
                type: 'text',
                secure: false, 
                multiline: false, 
                placeholder: '',
                defaultValue: ''
            }
        ])
    }, [])
        
    const config = useConfig()
    const sigmaData = useElementData(config.source)

    const { value, label, theme, format, helpText, percentage } = config
    const val = (Object.keys(sigmaData).length && value) ? sigmaData[value][0] : null
    const per = (Object.keys(sigmaData).length && percentage) ? sigmaData[percentage][0] : null

    return (
        <>
            <zero-amount-percent
                data-fill={themes[theme]?.dark}
                data-bg={themes[theme]?.light}
                data-value={val}
                data-label={label}
                data-percentage={per}
                data-format={format}
                data-help={helpText}></zero-amount-percent>
        </>
    )
}
